export class State {
    sendThirdPartyPaymentEmailError = {};
    sendThirdPartyPaymentEmailSuccess = {};
    isSendThirdPartyPaymentEmailLoading = false;
    selectedEducation = {};
}
